import React from 'react';
import { BaasicButton } from 'core/components';

// Previous/Next under a paged table, with which rows are showing.
const Pager = ({ t, page, onPage }) =>
	page.pageCount > 1 && (
		<div className="flex--primary spc--top--sml">
			<BaasicButton
				className="btn btn--sml btn--ghost spc--right--sml"
				type="button"
				label="BILLING.PREVIOUS"
				disabled={page.page === 0}
				onClick={() => onPage(page.page - 1)}
			/>
			<span className="type--sml spc--right--sml">
				{t('BILLING.ROWSSHOWING', {
					from: page.page * page.size + 1,
					to: page.page * page.size + page.rows.length,
					total: page.total,
				})}
			</span>
			<BaasicButton
				className="btn btn--sml btn--ghost"
				type="button"
				label="BILLING.NEXT"
				disabled={page.page >= page.pageCount - 1}
				onClick={() => onPage(page.page + 1)}
			/>
		</div>
	);

// A table showing one page (from pageOf) with its pager. A new page starts at its first row: the table's own scroll
// box goes back to the top and that top is brought into view.
const BillingPaged = ({ t, page, onPage, children }) => {
	const wrapper = React.useRef(null);
	const goToPage = p => {
		onPage(p);
		const scrollBox = wrapper.current.querySelector('.billing__scroll');
		if (scrollBox) {
			scrollBox.scrollTop = 0;
			scrollBox.scrollIntoView({ block: 'nearest' });
		}
	};
	return (
		<div ref={wrapper}>
			{children}
			<Pager t={t} page={page} onPage={goToPage} />
		</div>
	);
};

export default BillingPaged;
